import React, { useState, useEffect } from 'react';
import Box from '3box';
import Card from './Card';
const spaceName = 'dappr';
const threadName = 'users';

export default function Swiper({ theSpace }) {
  const [posts, setposts] = useState(null);
  useEffect(() => {
    (async () => {
      const posts = await Box.getThread(
        spaceName,
        threadName,
        '0x931D387731bBbC988B312206c74F77D004D6B84b',
        false,
      );
      console.log(posts);
      setposts(posts);
    })();
  }, [theSpace]);

  if (posts === null) {
    return (
      <div>
        <Card />
      </div>
    );
  } else {
    return (
      <div>
        {' '}
        <ol>
          {posts.map(post => (
            <li key={post}>{post}</li>
          ))}
        </ol>
      </div>
    );
  }
}
